import { useState } from 'react'
import WagerBoard from '../WagerSystem/WagerBoard'
import CreateWagerModal from './CreateWagerModal'
import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'

interface BroUser {
  id: string
  telegram_id: string
  brocode: string
  rank: string
  bro_score: number
  is_brometheus: boolean
  twitter_handle?: string
}

interface WagersProps {
  user: BroUser
}

const MiniAppWagers = ({ user }: WagersProps) => {
  const [showCreateModal, setShowCreateModal] = useState(false)

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-tan font-bold text-lg">Wagers & Challenges</h2>
        <Button 
          onClick={() => setShowCreateModal(true)}
          className="bg-tan text-navy hover:bg-tan-dark"
          size="sm"
        >
          <Plus size={16} className="mr-1" />
          Create Challenge
        </Button>
      </div>
      
      <WagerBoard userId={user.id} currentUser={user} />
      
      <CreateWagerModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        user={user}
        onWagerCreated={() => {
          // Refresh wager board - could implement a refresh callback
        }}
      />
    </div>
  )
}

export default MiniAppWagers